module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"current":"Current password","new":"New password","repeat":"Repeat new password","confirm":"Change","changed":"Password changed successfully"},"de":{"current":"Aktuelles Passwort","new":"Neues Passwort","repeat":"Neues Passwort wiederholen","confirm":"Ändern","changed":"Passwort erfolgreich geändert"}}')
  delete Component.options._Ctor
}
